export function isArrayWithLength<T extends unknown[]>(
  arr: unknown
): arr is T {
  return Array.isArray(arr) && arr.length > 0
}
